export const celsiusToFarenheit = (tc: number, sf: number = 100) => Math.round((tc * 1.8 + 32) * sf) / sf
export const farenheitToCelsus = (tf: number, sf: number = 100) => Math.round((tf - 32) * (5 / 9) * sf) / sf
export const degreesFarenheit = '\xB0F'
export const degreesCelsius = '\xB0C'
